import { ReactNode } from 'react'
import { Segmented } from 'antd'

export type PublisherTabKey = 'basic' | 'filtering' | 'payment'

export type PublisherTabItem = {
    key: PublisherTabKey
    label: string
    disabled?: boolean
}

type PublisherTabsProps = {
    tabs: PublisherTabItem[]
    activeTab: PublisherTabKey
    onTabChange: (key: PublisherTabKey) => void
}

const PublisherTabs = ({ tabs, activeTab, onTabChange }: PublisherTabsProps): ReactNode => {
    return (
        <Segmented
            value={activeTab}
            options={tabs.map((tab) => ({
                label: tab.label,
                value: tab.key,
                disabled: tab.disabled,
            }))}
            onChange={(value) => onTabChange(value as PublisherTabKey)}
        />
    )
}

export default PublisherTabs
